/**
 * useListingQueryViewModel — derives display values from a React Query result.
 *
 * A11 from listing-abstraction-opportunities.md
 *
 * Extracts the repetitive rows/totalCount/totalPages derivation from query
 * data. The query result type must expose { data: TRow[]; total: number }
 * (or a compatible shape via the getTotalCount accessor).
 */
import { useMemo } from 'react';
export function useListingQueryViewModel({ query, pageSize, getRows, getTotalCount }) {
    const defaultGetRows = (d) => { var _a; return (_a = d.data) !== null && _a !== void 0 ? _a : []; };
    const defaultGetTotalCount = (d) => { var _a; return (_a = d.total) !== null && _a !== void 0 ? _a : 0; };
    const resolvedGetRows = getRows !== null && getRows !== void 0 ? getRows : defaultGetRows;
    const resolvedGetTotalCount = getTotalCount !== null && getTotalCount !== void 0 ? getTotalCount : defaultGetTotalCount;
    const rows = useMemo(() => (query.data ? resolvedGetRows(query.data) : []), [query.data, resolvedGetRows]);
    const totalCount = useMemo(() => (query.data ? resolvedGetTotalCount(query.data) : 0), [query.data, resolvedGetTotalCount]);
    const totalPages = useMemo(() => (pageSize > 0 ? Math.ceil(totalCount / pageSize) : 1), [totalCount, pageSize]);
    return {
        rows,
        totalCount,
        totalPages,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch
    };
}
